export default {
  data() {
    return {
      hoverOption: null,
      activedescendant: null
    };
  },

  computed: {
    optionsAllDisabled() {
      return this.options.every(option => option.disabled);
    }
  },

  watch: {
    hoverIndex(val) {
      const itemId = this.menuItemsArray[val] && this.menuItemsArray[val].id;
      const option = this.options.find(option => {
        return option.itemId === itemId;
      });

      if (typeof val === 'number' && val > -1) {
        this.hoverOption = option || {};
      }
      this.options.forEach(option => {
        if (val === -1) {
          option.hover = false;
        } else {
          option.hover = this.hoverOption === option;
        }
      });
    }
  },

  methods: {
    navigateOptions(direction) {
      if (this.menuItemsArray.length === 0 || this.optionsAllDisabled) {
        return;
      }
      const itemLength = this.menuItemsArray.length;
      if (direction === 'next') {
        this.hoverIndex++;
        if (this.hoverIndex >= itemLength) {
          this.hoverIndex = 0;
        }
      } else if (direction === 'prev') {
        this.hoverIndex--;
        if (this.hoverIndex < 0) {
          this.hoverIndex = itemLength - 1;
        }
      } else if (direction === 'home') {
        this.hoverIndex = 0;
      } else if (direction === 'end') {
        this.hoverIndex = itemLength - 1;
      }
      const itemId = this.menuItemsArray[this.hoverIndex] && this.menuItemsArray[this.hoverIndex].id;
      const option = this.options.find(option => {
        return option.itemId === itemId;
      });
      if (option.disabled) {
        this.navigateOptions(direction);
      }
      this.$nextTick(() => {
        this.activedescendant = this.hoverOption.itemId;
      });
    }
  }
};
